import React from 'react'
import { DateTime } from 'luxon'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

function Footer() {
  const data = useStaticQuery(graphql`
    query Footer {
      allGhostSettings {
        nodes {
          ...GhostSettingsFields
        }
      }
      allGhostPost(sort: { published_at: DESC }, limit: 3) {
        nodes {
          ...GhostPostFields
        }
      }
    }
  `)

  const [site] = data.allGhostSettings.nodes

  return (
    <footer id="main-footer">
      <div className="container">
        <div id="footer-widgets" className="clearfix">
          <div className="footer-widget">
            <div className="fwidget et_pb_widget widget_text">
              <h4 className="title">About Affio</h4>
              <div className="textwidget">
                <p>{site.description}</p>
                <Link to="/about-us">More about us</Link>
              </div>
            </div>
            <div className="fwidget et_pb_widget widget_text">
              <div className="textwidget">
                <p>&nbsp;</p>
                <p>We accept the following cards:</p>
                <StaticImage
                  src="../../images/credit-cards.png"
                  alt="Accepted credit cards"
                  width={190}
                  objectFit="none"
                />
              </div>
            </div>
          </div>
          <div className="footer-widget">
            <div
              id="nav_menu-2"
              className="fwidget et_pb_widget widget_nav_menu"
            >
              <h4 className="title">Knowledge Base</h4>
              <div className="menu-knowledge-base-container">
                <ul id="menu-knowledge-base" className="menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base">Knowledge Base</Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base/the-basics">The Basics</Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base/friends-family">
                      Friends &amp; Family
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base/your-assets">Your Assets</Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base/your-wishes">Your Wishes</Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base/what-happens-next">
                      What Happens Next?
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page">
                    <Link to="/knowledge-base/glossary">Glossary</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-widget last">
            <div
              id="rpwe_widget-3"
              className="fwidget et_pb_widget rpwe_widget recent-posts-extended"
            >
              <h4 className="title">Recent Posts</h4>
              <div className="rpwe-block">
                <ul className="rpwe-ul">
                  {data.allGhostPost.nodes.map((post) => (
                    <li key={post.id} className="rpwe-li rpwe-clearfix">
                      <h3 className="rpwe-title">
                        <Link
                          to={`/${post.slug}`}
                          title={post.title}
                          rel="bookmark"
                        >
                          {post.title}
                        </Link>
                      </h3>
                      <time
                        className="rpwe-time published"
                        dateTime={post.published_at}
                      >
                        {DateTime.fromISO(post.published_at).toFormat(
                          'LLLL d, y',
                        )}
                      </time>
                      <div className="rpwe-summary">
                        {post.excerpt}{' '}
                        <Link to={`/${post.slug}`}>Read More »</Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer-bottom">
        <div className="clearfix container">
          <hr />
          <ul id="et-social-icons">
            <li className="et-social-icon et-social-facebook">
              <a
                href="https://www.facebook.com/affiouk"
                rel="noreferrer"
                target="_blank"
              >
                <span>Facebook</span>
              </a>
            </li>
            <li className="et-social-icon et-social-twitter">
              <a
                href="https://twitter.com/affiouk"
                rel="noreferrer"
                target="_blank"
              >
                <span>Twitter</span>
              </a>
            </li>
            <li className="et-social-icon et-social-rss">
              <Link to="/rss.xml">
                <span>RSS</span>
              </Link>
            </li>
          </ul>
          <p id="footer-info">
            © 2014 - {new Date().getFullYear()} affio UK Online Will Writing
            Service - get started for free!&nbsp;&nbsp; &nbsp;{' '}
            <Link to="/terms-and-conditions">Terms and Conditions</Link> |{' '}
            <Link to="/privacy">Privacy Policy</Link> |{' '}
            <Link to="/cookies">Cookie Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
